<div class="tooltip tooltip-{{ position }}">
    <div #ref>
        <ng-content></ng-content>
    </div>
    <i *ngIf="!ref.childNodes.length" class="i i-question"></i>
    <div class="tooltip-tip" [innerHTML]="message | translate: params"></div>
</div>
